import { Form as FormInicial, message, Typography, Tooltip, Empty } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Form,
    FormItem,
    InputNumberItem,
    ModalItem,
    ButtonItem,
    ErrorItem,
} from "../../../../Components/Items";
import axios from "axios";
import moment from "moment";

const { Text } = Typography;

class ElegirPedidoInsumo extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        pedidos: [],
        insumo: {},
    };

    componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.visible) {
            this.consultarPedidosDisponibles();
        }
    }

    cerrarElegirPedido = () => {
        const pedidos = this.formRef.current?.getFieldValue("pedidos");
        const pedidosFiltrados = pedidos && Array.isArray(pedidos)
            ? pedidos
                .filter((p) => p.cantidad && p.cantidad > 0)
                .map((p) => {
                    const pedidoCompleto = this.state.pedidos.find(
                        (pp) =>
                            pp.pedidoId?.toString() === p.pedidoId?.toString() &&
                            pp.insumoIdPedido?.toString() === p.insumoIdPedido?.toString()
                    );
                    return {
                        pedidoId: p.pedidoId,
                        insumoIdPedido: p.insumoIdPedido,
                        cantidad: p.cantidad,
                        numeroPedido: p.numeroPedido,
                        ordenDeCompra: pedidoCompleto?.ordenDeCompra || "",
                    };
                })
            : [];

        let leyenda = "";
        if (pedidosFiltrados.length > 0) {
            const insumoDesc = this.state.insumo?.descripcion || "";
            if (pedidosFiltrados.length === 1) {
                leyenda = `${insumoDesc}, DELIVERY ORDER ${pedidosFiltrados[0].ordenDeCompra || ""}`;
            } else {
                const detalle = pedidosFiltrados
                    .map((p) => `${p.ordenDeCompra || ""} (${p.cantidad})`)
                    .join(", ");
                leyenda = `${insumoDesc}, DELIVERY ORDER ${detalle}`;
            }
        }

        this.props.cerrarElegirPedido(pedidosFiltrados, leyenda);
        this.formRef.current?.resetFields();
        this.setState({ pedidos: [], insumo: {} });
    };

    async consultarPedidosDisponibles() {
        if (!this.props.clienteId || !this.props.insumoId) {
            message.warning("Selecciona cliente e insumo primero");
            this.props.cerrarElegirPedido(null);
            return;
        }
        this.setState({ loading: true });
        await axios
            .post(
                "pedidos/selectPedidosPorClienteInsumo",
                {
                    empresaId: this.props.empresaId,
                    insumoId: this.props.insumoId,
                    clienteId: this.props.clienteId,
                },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    const pedidosPrev = this.props.pedidosOrigen || [];
                    const nuevosPedidos = (res.data.pedidos || []).map((p) => {
                        const previo = pedidosPrev.find(
                            (pp) =>
                                pp.pedidoId?.toString() === p.pedidoId?.toString() &&
                                (!pp.insumoIdPedido ||
                                    pp.insumoIdPedido?.toString() === p.insumoIdPedido?.toString())
                        );
                        return {
                            ...p,
                            cantidad: previo?.cantidad || 0,
                        };
                    });
                    this.setState({
                        pedidos: nuevosPedidos,
                        insumo: res.data.insumo || {},
                    });
                    this.formRef.current?.setFieldsValue({ pedidos: nuevosPedidos });
                } else if (res.data.success === 1) {
                    message.warning(res.data.message);
                } else {
                    message.error("Hubo un error al consultar los pedidos disponibles");
                }
            })
            .catch(() => {
                message.error("Hubo un error al consultar los pedidos disponibles");
            });
        this.setState({ loading: false });
    }

    onFinish() {
        this.cerrarElegirPedido();
    }

    onFinishFailed(e) {
        ErrorItem(e);
    }

    render() {
        const nombreInsumo = this.state.insumo?.descripcion || "Cargando insumo...";
        const codigoInsumo = this.state.insumo?.clave || "";
        const cantidadObjetivo = this.props.cantidad || 0;

        return (
            <ModalItem
                title={`Elegir Pedido : ${codigoInsumo ? codigoInsumo + " - " : ""}${nombreInsumo}`}
                visible={this.props.visible}
                spinning={this.state.loading}
                onCancel={this.cerrarElegirPedido}
                paddingTop
                width={1000}
            >
                <Form
                    ref={this.formRef}
                    name="elegirPedidoInsumo"
                    layout
                    bottom={
                        <FormItem noStyle shouldUpdate>
                            {({ getFieldValue }) => {
                                const pedidos = getFieldValue("pedidos") || [];
                                const sumActual = pedidos.reduce(
                                    (s, p) => s + (Number(p?.cantidad) || 0),
                                    0
                                );
                                const coincide = sumActual === cantidadObjetivo;
                                return (
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            marginTop: 20,
                                            gap: 12,
                                        }}
                                    >
                                        <div style={{ fontSize: 14 }}>
                                            <Text>
                                                Cantidad requerida: <b>{cantidadObjetivo}</b>
                                                {"  |  "}
                                                Asignada:{" "}
                                                <b style={{ color: coincide ? "#52c41a" : "#ff4d4f" }}>
                                                    {sumActual}
                                                </b>
                                            </Text>
                                        </div>
                                        <ButtonItem
                                            type="primary"
                                            htmlType="submit"
                                            style={{ minWidth: 120 }}
                                        >
                                            Confirmar Pedidos
                                        </ButtonItem>
                                    </div>
                                );
                            }}
                        </FormItem>
                    }
                    onFinish={this.onFinish.bind(this)}
                    onFinishFailed={this.onFinishFailed}
                >
                    <FormInicial.List name="pedidos">
                        {(fields) => (
                            <div
                                style={{
                                    border: "1px solid #f0f0f0",
                                    borderRadius: "8px",
                                    overflowX: "auto",
                                    boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                                }}
                            >
                                <table style={{ width: "100%", borderCollapse: "collapse", textAlign: "left" }}>
                                    {fields.length > 0 ? (
                                        <thead style={{ backgroundColor: "#fafafa", borderBottom: "1px solid #f0f0f0" }}>
                                            <tr>
                                                <th style={{ padding: "12px 16px", fontWeight: 600, color: "#262626" }}>Pedido</th>
                                                <th style={{ padding: "12px 16px", fontWeight: 600, color: "#262626" }}>Orden de Compra</th>
                                                <th style={{ padding: "12px 16px", fontWeight: 600, color: "#262626" }}>Fecha</th>
                                                <th style={{ padding: "12px 16px", fontWeight: 600, color: "#262626" }}>Proyecto</th>
                                                <th style={{ padding: "12px 16px", fontWeight: 600, color: "#262626" }}>Faltante</th>
                                                <th style={{ padding: "12px 16px", fontWeight: 600, color: "#262626" }}>Cantidad a Tomar</th>
                                            </tr>
                                        </thead>
                                    ) : null}

                                    <tbody>
                                        {fields.length === 0 && !this.state.loading && (
                                            <tr>
                                                <td colSpan="6" style={{ padding: "40px", textAlign: "center" }}>
                                                    <Empty description="No hay pedidos abiertos para este insumo" />
                                                </td>
                                            </tr>
                                        )}

                                        {fields.map(({ key, name, fieldKey, ...restField }, arrayKey) => {
                                            const pedidoData = this.state.pedidos[arrayKey] || {};
                                            const faltante = Number(pedidoData.cantidadFaltante) || 0;

                                            return (
                                                <tr key={key} style={{ borderBottom: "1px solid #f0f0f0" }}>
                                                    <td style={{ padding: "12px 16px" }}>
                                                        <Text strong style={{ color: "#595959" }}>
                                                            {pedidoData.numeroPedido || pedidoData.numero || "-"}
                                                        </Text>
                                                    </td>
                                                    <td style={{ padding: "12px 16px" }}>
                                                        <Text>{pedidoData.ordenDeCompra || "-"}</Text>
                                                    </td>
                                                    <td style={{ padding: "12px 16px" }}>
                                                        <Text type="secondary">
                                                            {pedidoData.fechaPedido
                                                                ? moment(pedidoData.fechaPedido).locale("es").format("DD/MM/YYYY")
                                                                : "-"}
                                                        </Text>
                                                    </td>
                                                    <td style={{ padding: "12px 16px" }}>
                                                        <Text>{pedidoData.proyectoNombre || "-"}</Text>
                                                    </td>
                                                    <td style={{ padding: "12px 16px" }}>
                                                        <Text strong style={{ color: "#00b5e2", fontSize: "15px" }}>
                                                            {faltante}
                                                        </Text>
                                                    </td>
                                                    <td style={{ padding: "12px 16px" }}>
                                                        <FormItem noStyle shouldUpdate>
                                                            {({ getFieldValue }) => {
                                                                const pedidos = getFieldValue("pedidos") || [];
                                                                const sumOtros = pedidos.reduce(
                                                                    (s, p, i) =>
                                                                        i !== arrayKey ? s + (Number(p?.cantidad) || 0) : s,
                                                                    0
                                                                );
                                                                const restanteObjetivo = cantidadObjetivo
                                                                    ? Math.max(0, cantidadObjetivo - sumOtros)
                                                                    : Infinity;
                                                                const maxEfectivo = Math.min(faltante, restanteObjetivo);
                                                                return (
                                                                    <div style={{ display: "flex", alignItems: "center", gap: "8px", minWidth: "180px" }}>
                                                                        <FormItem
                                                                            {...restField}
                                                                            name={[name, "cantidad"]}
                                                                            numberCero
                                                                            noStyle
                                                                            type="number"
                                                                            max={maxEfectivo}
                                                                        >
                                                                            <InputNumberItem
                                                                                placeholder={`Máx: ${maxEfectivo}`}
                                                                                style={{ flex: 1 }}
                                                                            />
                                                                        </FormItem>
                                                                        <Tooltip title="Asignar máximo disponible">
                                                                            <ButtonItem
                                                                                lima
                                                                                type="default"
                                                                                size="small"
                                                                                onClick={() => {
                                                                                    const updated = [
                                                                                        ...this.formRef.current.getFieldValue("pedidos"),
                                                                                    ];
                                                                                    updated[arrayKey].cantidad = maxEfectivo;
                                                                                    this.formRef.current.setFieldsValue({ pedidos: updated });
                                                                                }}
                                                                            >
                                                                                Max
                                                                            </ButtonItem>
                                                                        </Tooltip>
                                                                        {/* Hidden ids para conservar referencia */}
                                                                        <FormItem {...restField} name={[name, "pedidoId"]} hidden>
                                                                            <input />
                                                                        </FormItem>
                                                                        <FormItem {...restField} name={[name, "insumoIdPedido"]} hidden>
                                                                            <input />
                                                                        </FormItem>
                                                                        <FormItem {...restField} name={[name, "numeroPedido"]} hidden>
                                                                            <input />
                                                                        </FormItem>
                                                                    </div>
                                                                );
                                                            }}
                                                        </FormItem>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </FormInicial.List>
                </Form>
            </ModalItem>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
    };
};

export default connect(mapStateToProps)(ElegirPedidoInsumo);
